<template>
  <v-container fluid>
    <!-- Organizations List -->
    <v-row justify="center">
      <v-col
        v-for="(organization, index) in organizations"
        :key="index"
        cols="12"
        sm="4"
        md="3"
      >
        <OrganizationCard :organization="organization"/>
      </v-col>
    </v-row>

    <!-- Pagination -->
    <v-row justify="center" class="mt-8">
      <v-col cols="12">
        <v-pagination
          v-if="pagination && pagination.length > 1"
          v-model="currentPage"
          :length="pagination.length"
          :disabled="pagination.disabled"
          @input="onPageChange"
          circle
        ></v-pagination>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import OrganizationCard from "@/components/OrganizationCard";

export default {
    components: { OrganizationCard },

    name: "OrganizationsList",

    props: {
        organizations: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            paginationDisabled: false,
        };
    },

    computed: {
        ...mapGetters("organizations", ["pagination"]),

        currentPage: {
            get() {
                return this.pagination.current;
            },
            set(value) {
                this.SET_CURRENT_PAGE(value);
            },
        }
    },

    methods: {
        ...mapMutations("organizations", ["SET_CURRENT_PAGE"]),
      
        onPageChange(page) {
            this.$emit("page-change", page);
        }
    }
};
</script>

